import axios from "axios";
const API_URL = "https://mighty-sierra-66153.herokuapp.com/";



// const API_URL = "http://localhost:3006";

// const API_URL = "http://localhost:3000";


let options = {
  baseURL: API_URL,
};

const axiosClient = axios.create(options);
// Add a response interceptor
axiosClient.interceptors.request.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // console.log("INSIDE INTERCEPTOR REQUEST")
    // console.log(localStorage.getItem("token"))
    if (localStorage.getItem("token")) {
      response.headers.Authorization = localStorage.getItem("token");
    }

    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);
export default axiosClient;
